import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, Table2, History, ArrowLeft, ArrowRight } from 'lucide-react';

const SECTIONS = [
  {
    id: 'upload',
    title: 'Subir Analitica de Sangre',
    description: 'Carga tus resultados via PDF o manualmente',
    icon: Upload,
    gradient: 'from-violet-500 to-purple-600',
    shadowColor: 'shadow-violet-500/20',
    path: '/client/analytics/upload',
  },
  {
    id: 'history-table',
    title: 'Historico de Resultados',
    description: 'Tabla acumulada de todos tus resultados',
    icon: Table2,
    gradient: 'from-blue-500 to-indigo-600',
    shadowColor: 'shadow-blue-500/20',
    path: '/client/analytics/history',
  },
  {
    id: 'uploads-list',
    title: 'Historial de Pruebas',
    description: 'Estudios subidos organizados por fecha',
    icon: History,
    gradient: 'from-teal-500 to-emerald-600',
    shadowColor: 'shadow-teal-500/20',
    path: '/client/analytics/uploads',
  },
];

const ClientAnalyticsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-4" data-testid="client-analytics-hub">
      <button
        onClick={() => navigate('/client/health')}
        className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors"
        data-testid="back-to-health"
      >
        <ArrowLeft size={16} /> Mi Cuerpo
      </button>

      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Analiticas de Sangre
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Gestiona tus estudios de laboratorio</p>
      </div>

      <div className="space-y-3">
        {SECTIONS.map((section, idx) => {
          const Icon = section.icon;
          return (
            <button
              key={section.id}
              onClick={() => navigate(section.path)}
              className={`w-full text-left bg-white rounded-2xl border border-gray-100/50 overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300`}
              style={{ animationDelay: `${idx * 80}ms` }}
              data-testid={`analytics-section-${section.id}`}
            >
              <div className={`h-1 bg-gradient-to-r ${section.gradient}`} />
              <div className="p-5 flex items-center gap-4">
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${section.gradient} flex items-center justify-center flex-shrink-0 shadow-lg ${section.shadowColor}`}>
                  <Icon size={24} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                    {section.title}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5 font-medium">{section.description}</p>
                </div>
                <ArrowRight size={18} className="text-gray-300 flex-shrink-0" />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ClientAnalyticsPage;
